import React from "react";
import ContentPasteGoIcon from "@mui/icons-material/ContentPasteGo";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface PreApproveButtonProps {
  langBase: string;
  permission: string;
  isActionAvailable: boolean;
  onApprove: () => void;
}

const PreApproveButton: React.FC<PreApproveButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onApprove,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="preApprove-button"
      testId="preApprove"
      variant="contained"
      startIcon={<ContentPasteGoIcon />}
      onClick={onApprove}
    />
  );
};
export default PreApproveButton;
